import React, { useEffect, useRef, useState } from 'react';
import Label from 'components/_utility/Label';
import YourFinanceQuote from 'components/YourFinanceQuote';
import { getImageBaseUrl } from 'helpers/request';
import { useDispatch, useSelector } from 'react-redux';
import { getCalculations, getFinanceOption } from 'src/redux/app/selectors';
import { setStep, setCalculations } from 'src/redux/app/actions';
import useDataLayer from 'src/hooks/useDataLayer';
import useLabel from 'src/hooks/useLabel';
import { STEPPER_HEIGHT } from 'src/config/constants';
import {
  Wrap,
  Title,
  Description,
  Breakdown,
  BreakdownDetails,
  BreakdownTitle,
  BreakdownDescription,
  BreakdownImage,
  Summary,
  EditButton,
  BreakdownImageWrap,
  BreakdownImageLabels,
  BreakdownImageLabel,
  QuoteWrapper,
} from './FinanceOptionSummary.styled';

const FinanceOptionSummary = ({ isSummaryPage = false }) => {
  const [showQuote, setShowQuote] = useState(true);
  const dispatch = useDispatch();
  const pushToDataLayer = useDataLayer();
  const getLabel = useLabel();
  const selectedFinanceOption = useSelector(getFinanceOption);
  const wrapRef = useRef();
  const calculations = useSelector(getCalculations);
  const lsQuoteRef = localStorage.getItem('quoteRef');

  useEffect(() => {
    if (!showQuote) {
      const y =
        wrapRef.current.getBoundingClientRect().top - document.body.getBoundingClientRect().top - STEPPER_HEIGHT;
      window.scrollTo(0, y);

      dispatch(setCalculations(null));
    }
  }, [showQuote]);

  return (
    <Wrap ref={wrapRef}>
      <Title>
        <Label name="financeOptionTitle"></Label>
      </Title>
      <Description>
        <Label name="financeOptionSubTitle"></Label>
      </Description>
      {!isSummaryPage && (
        <EditButton
          onClick={() => {
            dispatch(setStep(0));
            pushToDataLayer('editLink', {
              sectionEdit: getLabel('financeOptionsLabel'),
            });
          }}
        >
          <Label name="financeEditText"></Label>
        </EditButton>
      )}
      <Breakdown>
        <BreakdownDetails>
          <BreakdownTitle>{selectedFinanceOption.panelTitle}</BreakdownTitle>
          <BreakdownDescription
            dangerouslySetInnerHTML={{ __html: selectedFinanceOption.paneldescription }}
          ></BreakdownDescription>
        </BreakdownDetails>
        {selectedFinanceOption.image?.src ? (
          <BreakdownImageWrap>
            <BreakdownImage
              src={`${getImageBaseUrl()}${selectedFinanceOption.image.src}`}
              alt={selectedFinanceOption.image.alt}
            />
            {selectedFinanceOption.optionOne || selectedFinanceOption.optionTwo || selectedFinanceOption.optionThree ? (
              <BreakdownImageLabels
                count={
                  [
                    selectedFinanceOption.optionOne,
                    selectedFinanceOption.optionTwo,
                    selectedFinanceOption.optionThree,
                  ].filter(val => val).length
                }
              >
                {selectedFinanceOption.optionOne && (
                  <BreakdownImageLabel>{selectedFinanceOption.optionOne}</BreakdownImageLabel>
                )}
                {selectedFinanceOption.optionTwo && (
                  <BreakdownImageLabel>{selectedFinanceOption.optionTwo}</BreakdownImageLabel>
                )}
                {selectedFinanceOption.optionThree && (
                  <BreakdownImageLabel>{selectedFinanceOption.optionThree}</BreakdownImageLabel>
                )}
              </BreakdownImageLabels>
            ) : null}
          </BreakdownImageWrap>
        ) : null}
      </Breakdown>
      <Summary>
        <Label name="financeOptionsClosingText"></Label>
      </Summary>
      {selectedFinanceOption.didacticMention?.length > 0 && (
        <QuoteWrapper $highlight dangerouslySetInnerHTML={{ __html: selectedFinanceOption.didacticMention }} />
      )}
      {calculations || lsQuoteRef ? (
        <QuoteWrapper $bordered>
          {selectedFinanceOption.calculatorEnabled && (
            <YourFinanceQuote showQuote={showQuote} onSetShowQuote={setShowQuote} isSummaryPage={isSummaryPage} />
          )}
        </QuoteWrapper>
      ) : null}
    </Wrap>
  );
};

export default FinanceOptionSummary;
